<template>
    <dismissible-banner
        id="SystemMessageBanner"
        v-bind:banner-model="dismissibleModel"
        class="p-2">
        <template v-slot:default>
            <!-- eslint-disable vue/no-v-html -->
            <div v-html="bannerContentModel.LocalizedContent" />
            <!-- eslint-enable vue/no-v-html -->
        </template>
    </dismissible-banner>
</template>

<script setup>
    import dismissibleBanner from "./dismissibleBanner.vue";
    import { BANNER_STYLE } from "./banners";
    import { computed } from "vue";

    const props = defineProps({
        bannerContentModel: { type: Object, required: true }
    });

    const dismissibleModel = computed(() => {
        return {
            ShowBanner: Boolean(props.bannerContentModel.LocalizedContent),
            AllowHideIndefinite: false,
            ShowHideCOLSKey: `cols_pc_system_message_banner_${props.bannerContentModel.BannerTimestamp}`,
            BannerStyle: props.bannerContentModel.BannerStyleOverride ?? BANNER_STYLE.warning,
            AutoHideAfterMs: props.bannerContentModel.AutoHideOverride ?? 30000,
            HideExpirationDays: props.bannerContentModel.SuppressExpirationOverride ?? 1
        };
    });
</script>
